var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11378_19583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.81957 9.51V7.324H16.1856C16.2576 7.70467 16.2949 8.15533 16.2949 8.64333C16.2949 10.2833 15.8469 12.3113 14.4016 13.756C12.9962 15.2193 11.2009 16 8.82223 16C4.4129 16 0.705566 12.4087 0.705566 8C0.705566 3.59133 4.4129 0 8.82223 0C11.2616 0 12.9989 0.957333 14.3042 2.20467L12.7616 3.74667C11.8256 2.86867 10.5569 2.186 8.81957 2.186C5.60023 2.186 3.08223 4.78067 3.08223 8C3.08223 11.2193 5.60023 13.814 8.81957 13.814C10.9076 13.814 12.0969 12.9753 12.8589 12.2133C13.4769 11.5953 13.8836 10.7127 14.0436 9.50733L8.81957 9.51Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11378_19583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.c31e774c4e30a87683517ff269d8143d.svg";
export { ForwardRef as ReactComponent };